import { mapGetters, mapActions } from 'vuex'

import ScrollableList from '@/components/ScrollableList/index'
import PrivatePageWrapper from '@/components/PrivatePageWrapper/index'
import LazyImage from '@/components/LazyImage/index'

export default {
  name: 'results',
  components: {
    ScrollableList,
    PrivatePageWrapper,
    LazyImage
  },
  data: () => ({
    baseUrl: '',
    pageArr: null
  }),
  computed: {
    ...mapGetters('results', {
      resultsPageResponse: 'RESULTS_PAGE'
    })
  },
  methods: {
    ...mapActions('results', {
      fetchResultsPageAction: 'FETCH_RESULTS_PAGE'
    })
  },
  activated() {
    this.baseUrl = `/admin/move-fixtures`
    this.fetchResultsPageAction().then(() => {
      this.pageArr = {
        pages: this.resultsPageResponse.data,
        ongoingRound: this.resultsPageResponse.nearestRound
      }
    })
    this.$store.commit('SET_PAGE_TITLE', 'Game Rounds')
    this.$store.commit('SET_SHOW_SELECT_BUTTON', {
      show: true,
      label: 'Select'
    })
    this.$store.commit('SET_SHOW_LOGO', false)
  },
  deactivated() {
    this.$store.commit('SET_PAGE_TITLE', '')
    this.$store.commit('SET_SHOW_SELECT_BUTTON', { show: false, label: '' })
    this.$store.commit('SET_SHOW_LOGO', true)
  }
}
